import React from 'react';
import FaqStore from './flux/FaqStore';
import FAQpost from './FAQpost';

export default function FAQ(props) {
  if(!props.json.faqs || props.json.faqs.length < 1) {
    console.log(props.json.faqs);
    console.log('Zero blog posts.');
    return false
  }
  
  const posts = props.json.faqs;
  const sortedFaqs = FaqStore.parseFaqs(posts);

  console.log(window.location);

  return (
    <div className="faq">
      <nav className="faq-nav">
        <ul className="faq-nav-ul">
          {sortedFaqs.map((category) => {
            console.log(category);
            let thisCatTitle = false;
            category.tag === '' ? thisCatTitle = 'Miscelaneous' : thisCatTitle = category.tag;
            return (
              <li>
                <a
                  href={`#${thisCatTitle}`}
                  onClick={() => {
                    console.log(thisCatTitle);
                  }}
                >
                  {thisCatTitle}
                </a>
              </li>
            )
          })}
        </ul>
      </nav>
      <section className="faq-qa">
        <ul className="tags">
          {sortedFaqs.map((category) => {
            return (
              <li className="tag" id={category.tag}>
                <h2>{category.tag === '' ? 'Miscelaneous' : category.tag}</h2>
                <ul className="posts">
                  {category.posts.map((post) => {
                    return <FAQpost post={post} key={post.id} />
                  })}
                </ul>
              </li>
            );
          })}
        </ul>
      </section>
    </div>
  )
}